import {useContext} from "react";
import {AppContext} from "../../../context/AppContext";
import styles from './Summary.module.scss'

const Summary = ({ invoice }) => {
    const { windowWidth } = useContext(AppContext);
    const isDesktop = windowWidth >= 768;

    return (
        <div className={styles.summary}>
            <div className={styles.container}>
                {isDesktop && (
                    <div className={styles.head}>
                        <h5>Item Name</h5>
                        <h5 className={styles.textCenter}>QTY.</h5>
                        <h5 className={styles.textEnd}>Price</h5>
                        <h5 className={styles.textEnd}>Total</h5>
                    </div>
                )}
                {invoice.items.map((item, index) => (
                    <div className={styles.item} key={index}>
                        <p className={styles.name}>{item.name}</p>
                        <p className={styles.qty}>
                            {item.quantity}{' '}
                            {!isDesktop &&
                                ` x $ ${item.price}`}
                        </p>
                        {isDesktop && (
                            <p className={styles.price}>
                                {`$ ${item.price}`}
                            </p>
                        )}
                        <p className={styles.total}>
                            {`$ ${item?.total}`}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Summary;
